module.exports = [
  { id: "lg-ec", value: "Early Childhood" },
  { id: "lg-pe", value: "Primary Education" },
  { id: "lg-se", value: "Secondary Education" },
  { id: "lg-he", value: "Higher Education" },
  { id: "lg-ae", value: "Adult Education" },
  { id: "lg-pl", value: "Professional Learning" },
];
